import React from "react";
import { Callout, DocLink, DocSection, DocTable } from "../components/DocPrimitives";

// Where to report a problem in the Gait service itself (decided 2026-09-28;
// mail delivery verified). If this is ever unset (null), the page says plainly
// that no address is published: never put a guessed address here.
export const SECURITY_CONTACT = "security@gaitobservatory.com";

const SDK_SECURITY = "https://github.com/anthonynarine/gait-sdk/blob/main/docs/SECURITY.md";

export default function ReportAVulnerability() {
    return (
        <>
            <p className="doc-lede">
                If you think you've found a security problem in Gait or in gait-sdk, tell me privately so it can be
                fixed before anyone else finds it.
            </p>

            <DocSection id="where-to-report" title="Where to report">
                <DocTable caption="Where to report a vulnerability">
                    <thead>
                        <tr>
                            <th scope="col">Problem in</th>
                            <th scope="col">Report it</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Gait: the website, console or API</th>
                            <td>
                                {SECURITY_CONTACT ? (
                                    <a href={`mailto:${SECURITY_CONTACT}`}>{SECURITY_CONTACT}</a>
                                ) : (
                                    <span data-testid="security-contact-pending">
                                        Not published yet. A dedicated contact will be listed here.
                                    </span>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">gait-sdk, the Python package</th>
                            <td>
                                Privately on GitHub, through the gait-sdk repository's <em>Security → Report a
                                vulnerability</em>, or by contacting the maintainer on GitHub. Reports are acknowledged
                                within 72 hours. Details: <a href={SDK_SECURITY}>gait-sdk security policy</a>.
                            </td>
                        </tr>
                    </tbody>
                </DocTable>
                {!SECURITY_CONTACT && (
                    <Callout kind="note" title="Contact for the Gait service">
                        The address for reporting problems in the Gait service itself isn't published yet. Please
                        don't report a vulnerability in a public place in the meantime.
                    </Callout>
                )}
            </DocSection>

            <DocSection id="what-to-include" title="What to include">
                <ul>
                    <li>What's affected, and the version if it's gait-sdk.</li>
                    <li>The steps to reproduce it.</li>
                    <li>What someone could do with it.</li>
                </ul>
            </DocSection>

            <DocSection id="please-dont" title="Please don't">
                <ul>
                    <li>Open a public issue or post the details anywhere public.</li>
                    <li>
                        Include a real connection key, password or invite link. Describe what you did and what you saw
                        instead.
                    </li>
                </ul>
                <p>
                    For anything that isn't a security problem, see{" "}
                    <DocLink to="troubleshooting#still-stuck">Troubleshooting</DocLink>.
                </p>
            </DocSection>
        </>
    );
}
